import * as tslib_1 from "tslib";
import { AfterViewInit, ElementRef, ErrorHandler, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Business } from '../models/business.model';
import { QuickNavToc } from '../../shared/models/quick-nav-toc.model';
import { FlyingClubComponent } from '../flying-club/flying-club.component';
import { QuickNavComponent } from '../../shared/quick-nav/quick-nav.component';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { AirportService } from '../../airport/airport.service';
import { hasTag } from '../../util/tag-utils';
import { HelpDialogComponent } from '../help-dialog/help-dialog.component';
import { MatDialog } from '@angular/material';
import { AnalyticsService } from '../../airport/service/google-analytics-4.service';
import { AuthService } from '../../auth/auth/auth.service';
var FlyingclubDetailComponent = /** @class */ (function () {
    function FlyingclubDetailComponent(_route, _errorHandler, businessManagerService, _toggleService, _airportService, _matDialog, _analyticsService, _auth) {
        var _this = this;
        this._route = _route;
        this._errorHandler = _errorHandler;
        this.businessManagerService = businessManagerService;
        this._toggleService = _toggleService;
        this._airportService = _airportService;
        this._matDialog = _matDialog;
        this._analyticsService = _analyticsService;
        this._auth = _auth;
        this.isBusinessOwner = false;
        this.isFlightDeckAdmin = false;
        this.editModeSet = false;
        this.isAmbassador = false;
        this.isNotApproved = false;
        this.toc = new QuickNavToc('fbo-quicknav', [{
                label: 'Overview',
                fragment: 'overview',
                visible: true
            }, {
                label: 'Contact Info',
                fragment: 'contacts',
                visible: true
            }, {
                label: 'Flying Club Info',
                fragment: 'club',
                visible: function () { return _this.clubSection.hasContent; }
            }]);
    }
    FlyingclubDetailComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, _c;
            var _this = this;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        this._route.data
                            .subscribe(function (data) {
                            _this.business = data.business;
                        }, function (error) {
                            _this._errorHandler.handleError(error);
                        });
                        this._toggleService.toggleEmitter.subscribe(function (isOn) {
                            _this.editModeSet = isOn;
                        });
                        _a = this;
                        return [4 /*yield*/, this.businessManagerService.userOwnsBusiness(this.business.id)];
                    case 1:
                        _a.isBusinessOwner = _d.sent();
                        _b = this;
                        return [4 /*yield*/, this.businessManagerService.isFlightDeckAdmin()];
                    case 2:
                        _b.isFlightDeckAdmin = _d.sent();
                        if (!(hasTag(this.business.tags, 'Flying Club') && this.business.flyingClub)) return [3 /*break*/, 4];
                        _c = this;
                        return [4 /*yield*/, this.businessManagerService.isAmbassador()];
                    case 3:
                        _c.isAmbassador = _d.sent();
                        _d.label = 4;
                    case 4:
                        this.isNotApproved = hasTag(this.business.tags, 'Admin::BusinessNotApproved');
                        this._analyticsService.pageView('airport_flyingclub', 'Flying Club Detail');
                        this._analyticsService.trackEvent('airport_flyingclub_viewed', this.business.id.toString(), this.business.id.toString());
                        if (this._auth.authenticated && this._auth.endUser) {
                            this._analyticsService.trackEvent('airport_flyingclub_loggedin', this._auth.recid, this._auth.recid);
                        }
                        else {
                            this._analyticsService.trackEvent('airport_flyingclub_loggedout', '', '');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    FlyingclubDetailComponent.prototype.onReloadBusiness = function (reload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this._airportService.getBusiness(this.business.id.toString())];
                    case 1:
                        _a.business = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FlyingclubDetailComponent.prototype.ngAfterViewInit = function () {
        /*
        const $detailBody = $(this.body.nativeElement);
        const $page = $detailBody.closest('.detail-page');
        this.quicknav.setContainerHeight($page.height() + 1000);
        */
        if (hasTag(this.business.tags, 'Admin::BusinessNotApproved')) {
            this.showHelp();
        }
    };
    FlyingclubDetailComponent.prototype.showHelp = function () {
        var dialogRef = this._matDialog.open(HelpDialogComponent, {
            data: {
                businessType: 'Flying Club'
            }
        });
    };
    return FlyingclubDetailComponent;
}());
export { FlyingclubDetailComponent };
